<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    皇岗口岸站<br>
站点介绍<br>
皇岗口岸站位于百合三路与同庆路交叉处，沿百合三路东西方向布置。车站北侧为过境车辆缓冲停车场、地面停车场及公交站台，南侧为皇岗口岸办公楼，本站为皇岗口岸工作人员及进出香港人员的通行服务。皇岗口岸站以米白色为主色调，装修以造型简洁、尊重材料性能、讲究材料自身质地和色彩配置效果为设计特色。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:43	23:23	7号线	3分35秒	5分55秒<br>
太安	06:06	23:33	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:42	23:23	7号线	4分钟	5分55秒<br>
太安	06:05	23:33	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:43	00:23	7号线	4分钟	5分55秒<br>
太安	06:05	00:33	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
C出入口:<br>
同庆路东侧、百合三路北侧、深圳市口岸指挥中心大厦、皇岗海关<br><br>
D出入口:<br>
皇御院学校、皇岗口岸联检大楼、深港1号、皇城广场<br><br>
E出入口:<br>
福田南路西侧、百合三路北侧、同庆路东侧、廊桥国际、皇岗口岸汽车站<br><br>
F出入口:<br>
同庆路西侧、百合三路北侧<br>
公交换乘信息<br><br>
此站暂无数据:<br>
公交站名： 皇岗口岸<br>
326路,366路<br>
此站暂无数据:<br>
公交站名：<br>
暂无<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>